import React from 'react';

export default ({ id, children }) => (
  <div className='wea-intro-step' id={id}>
    {children}
  </div>
);



// WEBPACK FOOTER //
// ./ecology9/wea-intro/Step.js